import React from "react";

const Footer = () =>
{ return ( <div style={{ color: "#000062",  backgroundColor: "#d4d7db",  position: "absolute", 
                         margin:"auto", width: "1280px", textAlign: "right", }}>
              <div className="row">
                 <nav class="navbar navbar-expand-lg navbar-light bg-none">
                    <div class="collapse navbar-collapse" id="navbarText"></div>                    
                    <span className=" d-flex justify-content-end vertical-align-bottom">www.azed.fr  &copy;{new Date().getFullYear()} &nbsp;&nbsp; Site réalisé par Azeddine BOUZAD-KUHNEN</span>
                 </nav>
              </div>
           </div> )
}

export default Footer;